/* eslint-disable */
import React from 'react';
// import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
// import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
// @material-ui/icons
import People from "@material-ui/icons/People";
import Lock from '@material-ui/icons/Lock';
//core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import {alertActions, commonActions} from '../../_actions';
import {alertConstants, appConstants} from "../../_constants";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";
import Faan from 'assets/img/faan_logo2.png';
import {connect} from 'react-redux';
import { ProgressBar } from '../../utils/ProgressBar';
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import {AlertBar} from "../../utils/AlertBar.jsx";
import {store} from "../../_store";
import { InlinePageRequesting } from "../../utils/PageUtility";
import { appHelpers, history } from '../../_helpers';
import CookiesConsent from '../../views/policies/cookies-consent';

const styles = {
    space:{
      padding:'5px',
      textAlign:"left",
      fontSize: "12px"
    },
    space2:{
        padding:'8px',
        textAlign:"center",
    },
      policy: {
      textAlign:"left",
      fontSize: "12px",
      display: "block"
    },
    title:{
      fontWeight:'300',
        textAlign:"center"
    },
    root: {
        flexGrow: 1,
        width:'100%',
        height:'100vh',
        background:"url('img/airport2.jpg')",
        backgroundPosition:'center',
        backgroundSize:'cover',
        backgroundRepeat:'no-repeat',
    },
    overlay: {
        flexGrow: 1,
        width:'100%',
        height:'100%',
        background:"rgba(0,0,0,.6)"
    },
    paper: {
        textAlign: 'center',
    },
    center:{
        alignItems:'center',
        justifyContent:'center',
        width:'100%',
        height:'100%'
    },
    checked: {
        color: primaryColor + "!important"
    },
    checkedIcon: {
        width: "20px",
        height: "20px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    uncheckedIcon: {
        width: "0px",
        height: "0px",
        padding: "10px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    radio: {
        color: primaryColor + "!important"
    },
    radioChecked: {
        width: "20px",
        height: "20px",
        border: "1px solid " + primaryColor,
        borderRadius: "50%"
    },
    radioUnchecked: {
        width: "0px",
        height: "0px",
        padding: "10px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "50%"
    },
    flexBetween: {
       display: "flex",
       justifyContent: "space-between",
 
    }
};

class Login extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            checked: [],
            componentError:false,
            error: false,
            success: false,
            isRequesting: false,
            Username: '',
            Password: '',
            progress: false,
            cookieName: "pscweb:cc",
        };
        // this.processSubmit = this.processSubmit.bind(this);
    }
    componentDidMount(){
        const { alert } = store.getState();
        const { dispatch } = this.props;
        //check user is authenticated;
        if(alert){
            if(alert.type === alertConstants.SUCCESS ) {
                this.setState({error: false, success: alert.message});
            }
            else if(alert.type === alertConstants.CLEAR ){
                this.setState({success: false, error: false})
            }
            else if(alert.type === alertConstants.ERROR ){
                this.setState({success: false, error: alert.message });
                dispatch(alertActions.clear());
            }
        }
        // dispatch(commonActions.postSignOut());
        dispatch(alertActions.resetApp());
        this.toggleCookieDisplay();

    }
    componentWillReceiveProps = function (nextProps) {
        const { alert } = nextProps;
        if(alert){
            if(alert.type === alertConstants.SUCCESS ) {
                this.setState({error: false, success: alert.message});
            }
            else if(alert.type === alertConstants.CLEAR ){
                this.setState({success: false, error: false})
            }
            else if(alert.type === alertConstants.ERROR ){
                this.setState({success: false, error: alert.message })
            }
        }
    };
    validateInput = () => {
        const { Username, Password } = this.state;
        if(Username === ''){
            this.setState({componentError: 'Please enter username'});
        }
        else if(Password === ''){
            this.setState({componentError: 'Please enter password'});
        }else{
            this.setState({componentError: false});
            return true;
        }
    };

    handleChange= (event) => {
        this.setState({[event.target.name]:event.target.value})
    };
    handleSubmit = () => {
        const{ Username, Password } = this.state;
        const { dispatch } = this.props;
        this.resetError();
        if(this.validateInput){
            this.setState({progress: true});
            let payload = JSON.stringify({ Username, Password });
            dispatch(commonActions.postSignIn(payload));
        }else{
           this.setState({error: 'Provide valid details'})
        }
      };

    resetError = () => {
        // this.props.dispatch(alertActions.clear());
        this.setState({error: false})
    };

    renderPageResponse = () => {
        if(this.state.error){
            return ( <AlertBar
                message={typeof this.state.error === "object" ? this.state.error.Message : this.state.error}
            />);
            // return (<div className="alert alert-danger text-capitalize-first">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger text-capitalize-first">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success text-capitalize-first">{this.state.success}</div>);
        }
    }

     //cookies
  setCookies = (name, value, days) => {
    let expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    this.toggleCookieDisplay();
  };

  getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  toggleCookieDisplay = () => {
    const { cookieName } = this.state;
    let cookieObj = this.getCookie(cookieName);
    console.log(cookieObj, typeof cookieObj);
    let cookieWrapperElement = document.getElementById("cookies-policy-footer");
    if (cookieObj === null) {
      console.log("it is null");
      cookieWrapperElement.style.display = "flex";
    } else {
      console.log("it is not null");
      cookieWrapperElement.style.display = "none";
    }
  };
  render () {
      let pageResponse = this.renderPageResponse();
      let { requesting } = this.props;
      const {cookieName} = this.state;
      return (
          <div style={styles.root}>
              <ProgressBar progress={requesting}/>
              {/*<ProgressBarProvider isActive={progress.isActive } color="#db7093" />*/}
              <div style={styles.overlay}>
                  <Grid container style={styles.center}>
                      <Grid item lg={3} sm={12}>
                          <Card chart>
                              <CardHeader color="regional">
                                  <div style={{display:"flex",margin:"auto"}}><img src={Faan} style={{width:"30%",margin:"auto"}}/></div>
                                  <h4 style={styles.title}>PSC MANAGEMENT PORTAL</h4>
                              </CardHeader>
                              <CardBody>
                                  <form onSubmit={this.handleSubmit}>
                                  <FormControl style={{width:"100%"}}>
                                      {pageResponse}
                                      <CustomInput
                                          required
                                          labelText="Username"
                                          id="material"
                                          formControlProps={{
                                              fullWidth: true
                                          }}
                                          inputProps={
                                              {
                                              name:"Username",
                                              onChange:this.handleChange,
                                              endAdornment: (
                                                  <InputAdornment position="end">
                                                      <People />
                                                  </InputAdornment>
                                              )
                                          }}
                                      />
                                      <CustomInput
                                          required
                                          labelText="Password"
                                          type='password'
                                          id="material2"
                                          formControlProps={{
                                              fullWidth: true
                                          }}
                                          inputProps={{
                                              name:"Password",
                                              onChange:this.handleChange,
                                              endAdornment: (
                                                  <InputAdornment position="end">
                                                      <Lock />
                                                  </InputAdornment>
                                              )
                                          }}
                                      />
                                            <div style={styles.flexBetween}>
                                          <div>
                                              <Link to="/privacy-policy" style={styles.policy}>Privacy Policy</Link>
                                      <Link to="/customer-awareness-policy" style={styles.policy}>Customer Awareness Policy</Link>
                                          </div>
                                           <a href={appConstants.FORGOT_PASSWORD_URL} target='_blank' className={'small'} style={styles.space}>
                                          Forgot password ?
                                      </a>
                                      </div>
                                      {/* <a href={appConstants.FORGOT_PASSWORD_URL} target='_blank' className={'small'} style={styles.space}>
                                          Forgot password ?
                                      </a>
                                      <div style={styles.flexBetween}>
                                        
                                      <Link to="/privacy-policy" style={styles.policy}>Privacy Policy</Link>
                                      <Link to="/customer-awareness-policy" style={styles.policy}>Customer Awareness Policy</Link>
                                      </div> */}
                                    
                                      <div style={styles.space2}>
                                          {
                                              !requesting &&
                                              <Button
                                                  type="button"
                                                  color="regional"
                                                  disabled={requesting}
                                                  onClick={()=>{this.handleSubmit()}}
                                              >
                                                  Sign in
                                              </Button>
                                          }
                                          {
                                              requesting &&
                                              <InlinePageRequesting/>
                                          }
                                      </div>
                                  </FormControl>
                                  </form>
                              </CardBody>
                              {/*<CardFooter chart>*/}
                              {/*</CardFooter>*/}
                          </Card>
                      </Grid>
                  </Grid>
                  <Grid container style={{background:"rgba(0,0,0,.9)",color:"white"}}>
                      <Grid item lg={12}>
                          <p style={{textAlign:"center",color:"white"}}>© {new Date().getFullYear()} FAAN PSC Management Portal</p>
                      </Grid>
                  </Grid>
              <CookiesConsent setCookies={this.setCookies}
              cookieName={cookieName}/>
              </div>
              
                  
      </div>

      )
  }
}

function mapStateToProps(state, ownProps) {
    const { alert, user, requesting } = state;
    return {
        alert,
        user,
        requesting
    };
}


export default connect(mapStateToProps)(withStyles(dashboardStyle)(Login));



// WEBPACK FOOTER //
// ./src/layouts/Login/Login.jsx